"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CroppedImage = _interopRequireDefault(require("../Utils/CroppedImage"));

var _useAvatarForBot3 = _interopRequireDefault(require("../hooks/useAvatarForBot"));

var _useAvatarForUser3 = _interopRequireDefault(require("../hooks/useAvatarForUser"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  '& .webchat__imageAvatar__image': {
    width: '100%'
  }
});

var ImageAvatar = function ImageAvatar(_ref) {
  var fromUser = _ref.fromUser;

  var _useAvatarForBot = (0, _useAvatarForBot3.default)(),
      _useAvatarForBot2 = _slicedToArray(_useAvatarForBot, 1),
      avatarImageForBot = _useAvatarForBot2[0].image;

  var _useAvatarForUser = (0, _useAvatarForUser3.default)(),
      _useAvatarForUser2 = _slicedToArray(_useAvatarForUser, 1),
      avatarImageForUser = _useAvatarForUser2[0].image;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      imageAvatarStyleSet = _useStyleSet2[0].imageAvatar;

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', 'webchat__imageAvatar', imageAvatarStyleSet + '')
  }, _react.default.createElement(_CroppedImage.default, {
    alt: "",
    className: "webchat__imageAvatar__image",
    height: "100%",
    src: fromUser ? avatarImageForUser : avatarImageForBot,
    width: "100%"
  }));
};

ImageAvatar.defaultProps = {
  fromUser: false
};
ImageAvatar.propTypes = {
  fromUser: _propTypes.default.bool
};
var _default = ImageAvatar;
exports.default = _default;